import React, { useEffect, useState, useRef } from 'react';
import clsx from 'clsx';
import { useHistory } from 'react-router-dom'
import { makeStyles, Paper, CircularProgress, IconButton, Tooltip, Button } from '@material-ui/core';
import PhoneIcon from '@material-ui/icons/Phone';
import NoCompanyLogo from '../../Images/NoCompanyLogo.png';
import db, { auth } from '../../Backend/firebase/firebase';
import CheckUserProvider from '../../AllHooks/CheckUserProvider';
import EditIcon from '@material-ui/icons/Edit';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { uploadImage, getDownloadUrl, uploadImageInBase64, getRetailerProfile } from '../../Backend/firebase/user';
import CustomAlert from '../CustomAlert';
import Popup from '../Popup';
import UpdateProfile from './UpdateProfile';
import draftToHtml from 'draftjs-to-html';
import { sleep, resizeFileImage } from '../Models/CommonFunc';
import { Helmet } from 'react-helmet';

const useStyles = makeStyles((theme) => ({
    root: {

    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'initial',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: '100%',
        padding: '20px'
    },
}));

function StoreProfile() {
    const classes = useStyles();
    const history = useHistory()
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    const [retailerDetails, setRetailerDetails] = useState(null);
    const [allProducts, setAllProducts] = useState([]);
    const { userData } = CheckUserProvider();
    const fileInput = useRef(null);
    const [isUploading, setIsUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [openNotify, setOpenNotify] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');
    const [openPopup, setOpenPopup] = useState(false);
    const [retailerDetailsRemarks, setRetailerDetailsRemarks] = useState(null);
    const [isImageLoad, setIsImageLoad] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };
    const addressParts = [
        retailerDetails?.storeAddress,
        retailerDetails?.city,
        retailerDetails?.country,
        retailerDetails?.zipcode ? `- ${retailerDetails?.zipcode}` : null,
    ];

    useEffect(async () => {
        if (userData) {
            setIsLoading(true);
            try {
                const getEmpDetails = await getRetailerProfile(userData.uid);
                setRetailerDetails(getEmpDetails.retailer);
                setAllProducts(getEmpDetails.products);
                if (getEmpDetails.retailer.remarks) {
                    setRetailerDetailsRemarks(JSON.parse(getEmpDetails.retailer.remarks));
                }
                setIsLoading(false)
            } catch(error) {
                console.log("Error Occur in Get Retailer Profile", error)
                setIsLoading(false)
            }
        }
    }, [userData]);

    const fileChange = async (files) => {
        try {
            setIsUploading(true);
            var newFileImage = await resizeFileImage(files[0]);
            const ref = await uploadImageInBase64(userData.uid,
                newFileImage.substring(22),
                updateProgress);
            const downloadUrl = await ref.getDownloadURL();

            const docRef = db.doc(`/Users/${userData.uid}`);
            await docRef.update({
                retailerImage: downloadUrl
            });

            setIsUploading(false);
            setAlertType('success');
            setNotificationMessage("Store logo has been uploaded successfully!");
            setOpenNotify(true);
        } catch (error) {
            setIsUploading(false);
            setAlertType('error');
            setNotificationMessage(error.message);
            setOpenNotify(true);
        }
    }

    const updateProgress = (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setUploadProgress(progress);
    }

    return (
        <>
            {!userData || isLoading ?
                (<div className="row">
                    <div className="col-md-12 text-center p-4">
                        <CircularProgress />
                    </div>
                </div>) : <div className="companyProfile">
                    <div className="row mt-2">
                        <div className="col-md-8 companyProfile__col_8">
                            <Paper className={fixedHeightPaper}>
                                <div className="row">
                                    <div className="col-md-12 text-center" style={{ marginTop: '-40px' }}>
                                        {retailerDetails?.retailerImage ? <img src={retailerDetails?.retailerImage} alt="Retailer Logo" className="img-fluid p-3" />
                                            : <img src={NoCompanyLogo} alt="Retailer Logo" className="img-fluid" />}

                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <div className="d-flex flex-column">
                                            <span style={{ fontWeight: '500', fontSize: '18px', marginBottom: '10px' }}>Store Description</span>
                                            {retailerDetailsRemarks && retailerDetailsRemarks.blocks.length > 0 ? <div dangerouslySetInnerHTML={{ __html: draftToHtml(retailerDetailsRemarks) }} /> : 'No remarks available.'}
                                        </div>
                                    </div>
                                </div>
                            </Paper>
                        </div>
                        <div className="col-md-4">
                            <div className="row">
                                <Paper className={fixedHeightPaper} style={{ paddingLeft: '20px', paddingRIght: '20px' }}>
                                    <div className="col-md-12 mb-2">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <h5>Contact Information</h5>
                                            {
                                                (userData !== null && (userData?.userRole === 'Retailer' || userData?.userRole === 'SubAdmin')) ?
                                                    <Tooltip title="Edit retailer profile" placement="top">
                                                        <IconButton color="primary" aria-label="edit retailer profile"
                                                            onClick={() => {
                                                                setOpenPopup(true)
                                                                history.push("/activity/update-profile")
                                                            }}>
                                                            <EditIcon />
                                                        </IconButton>
                                                    </Tooltip> : ''
                                            }
                                        </div>
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        {addressParts?.filter(Boolean).join(", ") || "Address not available"}
                                    </div>
                                    {retailerDetails?.phoneNumber && <div className="col-md-12 mb-3">
                                        <div className="d-flex align-items-center">
                                            <PhoneIcon />&nbsp;&nbsp;
                                            {retailerDetails?.phoneNumber}
                                        </div>
                                    </div>}
                                    {retailerDetails?.storeCity && <div className="col-md-12 mb-2">
                                        <span style={{ fontWeight: '500', fontSize: '17px' }}>City Name:</span> {retailerDetails?.storeCity}
                                    </div>}
                                    <div className="col-md-12 mb-2">
                                        <span style={{ fontWeight: '500', fontSize: '17px' }}>Business Name:</span> {retailerDetails?.storeName}
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <span style={{ fontWeight: '500', fontSize: '17px' }}>Website:</span> {retailerDetails?.storeWebsite ? retailerDetails.storeWebsite : 'Not Added'}
                                    </div>
                                    {retailerDetails?.businessType && <div className="col-md-12 mb-2">
                                        <span style={{ fontWeight: '500', fontSize: '17px' }}>Business Type:</span> {retailerDetails?.businessType}
                                    </div>}
                                    {
                                        userData !== null && userData?.userRole === 'Retailer' ? <div className="col-md-12 mt-2">
                                            <span style={{
                                                color: '#0082ff', fontWeight: '500', fontSize: '18px',
                                                borderBottom: '1px solid #0082ff'
                                            }}>Update Logo</span><br /><br />
                                            <div className="d-flex align-items-center">
                                                <input type="file" accept=".png,.jpg,.jpeg" ref={fileInput}
                                                    onChange={(e) => fileChange(e.target.files)} style={{ display: 'none' }} />
                                                <Button
                                                    variant="contained"
                                                    color="default"
                                                    startIcon={<CloudUploadIcon />}
                                                    onClick={() => fileInput.current.click()}>
                                                    {isUploading ? <CircularProgress variant="determinate"
                                                        value={uploadProgress} size={25} />
                                                        : 'Upload'}
                                                </Button>
                                            </div>
                                        </div> : ''
                                    }
                                </Paper>
                            </div>
                        </div>
                    </div>
                </div>
            }

            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType}
                notificationMessage={notificationMessage} verticalPosition="bottom" horizontalPosition="center" />

            <Popup openPopup={openPopup} setOpenPopup={setOpenPopup} title="Profile" popupSize="lg">
                <UpdateProfile />
            </Popup>
        </>
    )
}

export default StoreProfile
